const TOKEN = /(https?:\/\/[^\s]+|[\w.+-]+@[\w-]+\.[\w.]+)/g;

const Linkify = ({ text }) =>
  text.split(TOKEN).map((part, i) => {
    if (i % 2 === 0) return part;
    const isMail = part.includes("@") && !part.startsWith("http");
    const href = isMail ? `mailto:${part}` : part;
    return (
      <a key={i} href={href} {...(isMail ? {} : { target: "_blank", rel: "noopener noreferrer" })} className="break-words font-semibold text-sky-800 underline underline-offset-4 hover:text-navy">
        {part}
      </a>
    );
  });

const Para = ({ text }) => (
  <p className="mt-4 whitespace-pre-line text-base leading-relaxed text-slate-700">
    <Linkify text={text} />
  </p>
);

export const LegalBody = ({ doc }) => (
  <article data-testid="legal-body">
    <div className="border-b border-navy/10 pb-8">
      {doc.intro.map((t) => (
        <p key={t} className="text-sm font-semibold uppercase tracking-[0.16em] text-slate-600">{t}</p>
      ))}
    </div>
    {doc.sections.map((s) => (
      <section key={s.h} className={s.sub ? "mt-8" : "mt-14"}>
        {s.sub ? (
          <h3 className="text-lg font-bold text-navy">{s.h}</h3>
        ) : (
          <h2 className="text-2xl font-extrabold tracking-tight text-navy sm:text-3xl">{s.h}</h2>
        )}
        {s.items.map((it, i) =>
          Array.isArray(it) ? (
            <ul key={i} className="mt-4 space-y-2 border-l-2 border-sky-200 pl-5">
              {it.map((li) => (
                <li key={li} className="text-base leading-relaxed text-slate-700"><Linkify text={li} /></li>
              ))}
            </ul>
          ) : (
            <Para key={i} text={it} />
          )
        )}
      </section>
    ))}
  </article>
);
